import { SVGProps } from 'react';

export const TrashIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3333 2.66668V0.444458H6.66667V2.66668H0V4.8889H20V2.66668H13.3333Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3334 17.1111H11.1112V10.4445H13.3334V17.1111ZM8.88957 17.1111H6.66735V10.4445H8.88957V17.1111ZM2.22314 6V19.3333C2.22314 20.5589 3.21981 21.5556 4.44537 21.5556H15.5565C16.782 21.5556 17.7787 20.5589 17.7787 19.3333V6H2.22314Z"
      fill="currentColor"
    />
  </svg>
);
